import { type ApolloError, useLazyQuery, useQuery } from '@apollo/client';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { Button, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { allConfigs } from 'src/api/configurations';
import { CALLBACK_URL, OAUTH_PROVIDER_NAME } from 'src/constants';
import { buildGetAuthURL } from 'src/dynamoQueries/oauth';
import { getConfig } from 'src/helpers/common';
import { BaseStyles } from './styles';

interface ConfigurationNode {
  optionKey: string;
  optionValue: string;
}

interface AllConfigurationsData {
  allConfigurations: {
    edges: Array<{
      node: ConfigurationNode;
    }>;
  };
}

interface OAuth2AuthUrlData {
  oauth2AuthUrl: string;
}

export const OAUTHLogin: React.FC = () => {
  const { data: providerNameData, loading: providerNameLoading } = useQuery<AllConfigurationsData>(allConfigs, {
    variables: { optionKey: OAUTH_PROVIDER_NAME },
  });
  const classes = BaseStyles();
  const [getAuthUrl, { data, loading, error }] = useLazyQuery<OAuth2AuthUrlData>(buildGetAuthURL(CALLBACK_URL()));

  let provider = providerNameLoading ? '...' : 'OAUTH Provider';

  if (providerNameData) {
    const configResult = getConfig(providerNameData, 'optionKey', OAUTH_PROVIDER_NAME) as ConfigurationNode | undefined;
    provider = configResult?.optionValue || provider;
  }

  const startAuthenticationWorkflow = (): void => {
    getAuthUrl();
  };

  useEffect(() => {
    if (data?.oauth2AuthUrl) {
      localStorage.setItem('originalURI', window.location.toString());
      window.location.href = data.oauth2AuthUrl;
    }
  }, [data]);

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => startAuthenticationWorkflow()}
        disabled={loading}
        className={classes.button}
      >
        <VpnKeyIcon className={classes.icon} />
        {loading || data ? <CircularProgress color="secondary" /> : `SIGN IN with ${provider}`}
      </Button>
      {error && (
        <Typography color="error" variant="body2">
          {(error as ApolloError).message}
        </Typography>
      )}
    </div>
  );
};
